import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import './PasswordReset.css';
import {
    FaLock, 
    FaEye,
    FaEyeSlash
} from 'react-icons/fa';
import API_BASE_URL from '../config/api'

const PasswordReset = () => {
    const [passwords, setPasswords] = useState({
        new_password: '',
        confirm_password: ''
    });
    const [loading, setLoading] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const { uid, token } = useParams();
    const navigate = useNavigate();

    const handleChange = (e) => {
        setPasswords({
            ...passwords,
            [e.target.name]: e.target.value
        });
    };

    const toggleNewPasswordVisibility = () => {
        setShowNewPassword(!showNewPassword);
    };

    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (passwords.new_password !== passwords.confirm_password) {
            Swal.fire({
                icon: 'error',
                title: 'Password Mismatch',
                text: 'The passwords you entered do not match. Please try again.',
                confirmButtonColor: '#4F46E5'
            });
            return;
        }

        // Password validation
        if (passwords.new_password.length < 8) {
            Swal.fire({
                icon: 'error',
                title: 'Invalid Password',
                text: 'Password must be at least 8 characters long.',
                confirmButtonColor: '#4F46E5'
            });
            return;
        }

        setLoading(true);

        console.log(token)

        try {
            await axios.post(`${API_BASE_URL}/api/reset-password/`, {
                token: token,
                new_password: passwords.new_password,
                confirm_password: passwords.confirm_password
            });

            await Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: 'Your password has been reset successfully.',
                timer: 2000,
                showConfirmButton: false,
                confirmButtonColor: '#4F46E5',
                willClose: () => {
                    navigate('/login');
                }
            });

        } catch (error) {
            console.error('Password reset error:', error);
            
            let errorMessage = 'Something went wrong. Please try again.';
            
            if (error.response?.data?.error) {
                errorMessage = error.response.data.error;
            } else if (error.response?.data?.message) {
                errorMessage = error.response.data.message;
            } else if (error.response?.data?.non_field_errors) {
                errorMessage = error.response.data.non_field_errors[0];
            }

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: errorMessage,
                confirmButtonColor: '#4F46E5'
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='login-page'>
            <div className='background-shapes'>
                <div className='shape shape-1'></div>
                <div className='shape shape-2'></div>
                <div className='shape shape-4'></div>
                <div className='shape shape-5'></div>
                <div className='shape shape-6'></div>
                <div className='shape shape-7'></div>
                <div className='shape shape-8'></div>
                <div className='shape shape-9'></div>
            </div>
            <div className='login-container'>
                <div className='logo-container'>
                    <img 
                        src="/celebration logo.png" 
                        alt="Company Logo" 
                        className='company-logo'
                        onError={(e) => {
                            e.target.style.display = 'none'
                            document.querySelector('.logo-text').style.display = 'block'
                        }}
                    />
                    <h2 className='logo-text' style={{display: 'none'}}>PMS</h2>
                </div>
                <form onSubmit={handleSubmit} className='login-form'>
                    <h1 style={{color: '#fffb'}}>Reset Password</h1>
                    
                    <div style={{marginTop: '30px'}} className='form-group'>
                        <label htmlFor='new_password'>New Password</label>
                        <div className='input-container'>
                            <i className='input-icon password-icon'><FaLock/></i>
                        <input
                                type={showNewPassword ? "text" : "password"}
                                id="new_password"
                            name="new_password"
                            value={passwords.new_password}
                            onChange={handleChange}
                                placeholder='Enter new password'
                            required
                            minLength="8"
                            />
                            <button
                                type="button"
                                className="password-toggle-btn"
                                onClick={toggleNewPasswordVisibility}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    color: '#666',
                                    cursor: 'pointer',
                                    padding: '8px',
                                    position: 'absolute',
                                    right: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>
                    </div>
                    
                    <div style={{marginTop: '30px'}} className='form-group'>
                        <label htmlFor='confirm_password'>Confirm Password</label>
                        <div className='input-container'>
                            <i className='input-icon password-icon'><FaLock/></i>
                        <input
                                type={showConfirmPassword ? "text" : "password"}
                                id="confirm_password"
                            name="confirm_password"
                            value={passwords.confirm_password}
                            onChange={handleChange}
                                placeholder='Confirm new password'
                            required
                            minLength="8"
                            />
                            <button
                                type="button"
                                className="password-toggle-btn"
                                onClick={toggleConfirmPasswordVisibility}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    color: '#666',
                                    cursor: 'pointer',
                                    padding: '8px',
                                    position: 'absolute',
                                    right: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>
                    </div>
                    
                    <button 
                        type='submit' 
                        className='login-button'
                        disabled={loading}
                        style={{marginTop: '40px'}}
                    >
                        <span className='button-text'>{loading ? 'Resetting Password...' : 'Reset Password'}</span>
                        {loading && <span className='spinner'></span>}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default PasswordReset;